import { createRef, forwardRef, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { useMediaQuery } from "react-responsive";

const RenderWhenInViewDefaultPlaceholder = forwardRef((props, ref) => {
  ref = ref || createRef();
  return <div className="render-placeholder" ref={ref} />;
});
RenderWhenInViewDefaultPlaceholder.displayName =
  "RenderWhenInViewDefaultPlaceholder";

const RenderWhenInView = ({
  Placeholder = RenderWhenInViewDefaultPlaceholder,
  placeholderProps = {},
  children
}) => {
  const isPrint = useMediaQuery({ query: "print" });
  const [renderFull, setRenderFull] = useState(false);
  const [ref, inView] = useInView({
    threshold: 0
  });

  useEffect(() => {
    if (inView && !renderFull) {
      setRenderFull(true);
    }
  }, [inView, renderFull]);

  return renderFull || isPrint ? (
    children
  ) : (
    <Placeholder ref={ref} {...placeholderProps} />
  );
};

export default RenderWhenInView;
